import { put, takeLatest, all, call } from "redux-saga/effects";
import { getTokenForDirectLoginAAD, getTokenForLocalUserFromIDP, verificationForDemandLogin } from "../api/directLogin";
import {
  directTenantVerifyFailed,
  getAuthTokenSuccess,
  getLoginDetailsSuccess,
  invalidLocalUser,
  loginUserSuccess,
  setIdpToken,
  setInvalidTenantUrl,
  setLocalUserLoginError,
  setLocalUserTokens,
  setLoginDetailsError,
  veriFiedLocalUser,
} from "../actions";
import { directLogin } from "../../constants/actionTypes";
import { toasterFlags } from "../../constants/componentConstants";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { localStorageHelper } from "../../utils";
import { directLoginStorage } from "../../utils/storageHelper";

export function* verifyDirectLogin({ payload }) {
  try {
    const isDemandLoginVerified = yield call(verificationForDemandLogin, payload);
    if (isDemandLoginVerified?.status === statusCode.Ok200) {
      yield put(getLoginDetailsSuccess({ status: isDemandLoginVerified?.status, data: isDemandLoginVerified?.data?.success }));
    } else {
      const errorData = isDemandLoginVerified?.response;
      toastNotification(toasterFlags.ERROR, isDemandLoginVerified?.data?.message);
      yield put(setInvalidTenantUrl({ status: errorData?.status, data: errorData?.data }));
    }
  } catch (err) {
    yield put(directTenantVerifyFailed(err));
  }
}

export function* getDirectLoginTokenForAAD({ payload }) {
  try {
    const isDemandLoginVerified = yield call(getTokenForDirectLoginAAD, payload);

    if (isDemandLoginVerified?.status === statusCode.Ok200) {
      yield put(getAuthTokenSuccess({ status: isDemandLoginVerified?.status, data: isDemandLoginVerified?.data?.success }));
    } else {
      const errorData = isDemandLoginVerified?.response;
      toastNotification(toasterFlags.ERROR, errorData?.data?.message);
      localStorageHelper.clear();
      sessionStorage.clear();
      let url = directLoginStorage.get("tenantUrl");
      window.location.replace(url);
    }
  } catch (err) {
    yield put(directTenantVerifyFailed(err));
  }
}

//this function is call for auto onBoarding = false (AAD)
export function* getDirectLoginForAutoOnBoardFalseAAD({ payload }) {
  try {
    const directLoginForAutoOnBoardFalseAAD = yield call(verificationForDemandLogin, payload);
    if (directLoginForAutoOnBoardFalseAAD?.status === statusCode.Ok200) {
      yield put(
        loginUserSuccess({ status: directLoginForAutoOnBoardFalseAAD?.status, data: directLoginForAutoOnBoardFalseAAD?.data?.success })
      );
    } else {
      const errorData = directLoginForAutoOnBoardFalseAAD?.response;
      toastNotification(toasterFlags.ERROR, directLoginForAutoOnBoardFalseAAD?.data?.message);
      yield put(setInvalidTenantUrl({ status: errorData?.status, data: errorData?.data }));
    }
  } catch (err) {
    yield put(directTenantVerifyFailed(err));
  }
}

//this function is call for IDP Users
export function* getDirectLoginForAutoOnBoardFalseIDP({ payload }) {
  try {
    const directLoginForAutoOnBoardFalseIDP = yield call(verificationForDemandLogin, payload);
    if (directLoginForAutoOnBoardFalseIDP?.status === statusCode.Ok200) {
      yield put(
        loginUserSuccess({ status: directLoginForAutoOnBoardFalseIDP?.status, data: directLoginForAutoOnBoardFalseIDP?.data?.success })
      );
    } else {
      const errorData = directLoginForAutoOnBoardFalseIDP?.response?.data;
      toastNotification(toasterFlags.ERROR, errorData?.message);
      yield put(setLoginDetailsError({ status: errorData?.status, data: errorData?.data }));
      // TODO: ADD error handling here
      // storageCleanUpFunction();
    }
  } catch (err) {
    yield put(directTenantVerifyFailed(err));
  }
}

// verify tokens generated from IDP after successful authentication of user from IDP
export function* getVerifiedDirectLoginTokenFromIDP({ payload }) {
  try {
    const directLoginForAutoOnBoardFalseIDP = yield call(getTokenForDirectLoginAAD, payload);
    if (directLoginForAutoOnBoardFalseIDP?.status === statusCode.Ok200) {
      yield put(setIdpToken({ status: directLoginForAutoOnBoardFalseIDP?.status, data: directLoginForAutoOnBoardFalseIDP?.data?.success }));
    } else {
      const errorData = directLoginForAutoOnBoardFalseIDP?.response?.data;
      toastNotification(toasterFlags.ERROR, errorData?.message);
      yield put(setIdpToken({ status: errorData?.status, data: errorData?.data }));
      // TODO: ADD error handling here
      // storageCleanUpFunction();
    }
  } catch (err) {
    yield put(directTenantVerifyFailed(err));
  }
}

// verify local user for demand login
export function* verifyDemandLoginLocalUser({ payload }) {
  try {
    const verifiedLocalUser = yield call(verificationForDemandLogin, payload);
    if (verifiedLocalUser?.status === statusCode.Ok200) {
      yield put(veriFiedLocalUser({ status: verifiedLocalUser?.status, data: verifiedLocalUser?.data?.success }));
    } else {
      const errorData = verifiedLocalUser?.response?.data;
      toastNotification(toasterFlags.ERROR, errorData?.message);
      yield put(invalidLocalUser({ status: errorData?.status, data: errorData?.data }));
      // TODO: ADD error handling here
      // storageCleanUpFunction();
    }
  } catch (err) {
    yield put(directTenantVerifyFailed(err));
  }
}

// Login function for local user for demand login
export function* demandLoginLocalUserFunction({ payload }) {
  try {
    //Api call to fetch token from idp
    const localUserTokenData = yield call(getTokenForLocalUserFromIDP, payload);
    if (localUserTokenData?.status === statusCode.Ok200 && localUserTokenData?.data) {
      let payload = {
        tenant_id: localStorageHelper.get("localTenantId"),
        token: localUserTokenData?.data?.accessToken,
      };
      //Api call to verify token and fetch user details
      const verifiedToken = yield call(getTokenForDirectLoginAAD, payload);
      if (verifiedToken?.status === statusCode.Ok200 && verifiedToken?.data) {
        let tokenData = {
          ...verifiedToken?.data?.success,
          accessToken: localUserTokenData?.data?.accessToken,
        };
        yield put(setLocalUserTokens({ data: tokenData, status: verifiedToken?.status }));
      } else {
        const errorData = verifiedToken?.response;
        toastNotification(toasterFlags.ERROR, errorData?.message);
        yield put(setLocalUserLoginError({ data: errorData?.data, status: errorData?.status }));
        localStorageHelper.clear();
        sessionStorage.clear();
      }
    } else {
      const errorData = localUserTokenData?.response?.data;
      toastNotification(toasterFlags.ERROR, errorData?.message);
      yield put(setLocalUserLoginError({ data: localUserTokenData?.data?.result, status: localUserTokenData?.status }));
      localStorageHelper.clear();
    }
  } catch (err) {
    toastNotification(toasterFlags.ERROR, "Something went wrong...!");
  }
}

export function* directLoginFunction() {
  yield takeLatest(directLogin.VERIFY_DIRECT_LOGIN_TENANT, verifyDirectLogin);
  yield takeLatest(directLogin.GET_DIRECT_LOGIN_AAD_TOKEN, getDirectLoginTokenForAAD);
  yield takeLatest(directLogin.DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_AAD, getDirectLoginForAutoOnBoardFalseAAD);
  yield takeLatest(directLogin.DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_IDP, getDirectLoginForAutoOnBoardFalseIDP);
  yield takeLatest(directLogin.GET_DIRECT_LOGIN_TOKEN_AUTO_ON_BOARD_IDP, getVerifiedDirectLoginTokenFromIDP);
  yield takeLatest(directLogin.VERIFY_DIRECT_LOGIN_LOCAL_USER, verifyDemandLoginLocalUser);
  yield takeLatest(directLogin.DIRECT_LOGIN_FOR_LOCAL_USER, demandLoginLocalUserFunction);
}

export default function* directLoginSaga() {
  yield all([directLoginFunction()]);
}
